import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import Helmet from 'react-helmet';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {SessionRequired} from '../../../lib/api/components/SessionRequired';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Route, Switch, withRouter} from "react-router-dom";
import {Dashboard} from "./Dashboard";
import ConfirmDeactivation from "./ConfirmDeactivation";
import {NoMatch} from "../../app/containers/NoMatch";

@injectIntl
export class Settings extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        session: ImmutablePropTypes.map.isRequired,
        intl: intlShape,
    }

    render() {
        const { dispatch, session } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Page>
                <Helmet title={formatMessage({ id: 'frontend.pagetitle.my_account' })} />
                <Page.Header />
                <SessionRequired dispatch={dispatch} session={session}>
                    <Switch>
                        <Route exact path='/settings' component={Dashboard} />
                        <Route exact path='/settings/deactivate' component={ConfirmDeactivation} />
                        <Route component={NoMatch}/>
                    </Switch>
                </SessionRequired>
                <Page.Footer />
            </Page>
        );
    }
}

export default withRouter(connect(state => ({
    session: state.session,
    dispatch: state.dispatch,
}))(Settings));
